{
  "root": "/",

  "faq": "/faq",
  "icons_faq": "/icons-faq",
  "noUsername": "/username-error",
  "notfound": "/notfound",
  "plus": "/plus",
  "promotions": "/promotions",
  "support": "/support",
  "terms": "/terms",
  "welcome": "/welcome",
  "worksWithWipper": "/works-with-wippersnapper",
  "public_user": "/:username/public",

  "sign_out": "/sign_out",

  "upgrade": "/upgrade",
  "upgrade_receipt": "/upgrade/receipt",
  "upgrade_cancel": "/upgrade/cancel",
  "upgrade_payment": "/upgrade/payment",

  "home": "/:username/overview",
  "profile": "/:username/overview",
  "sharing": "/:username/privacy",
  "activities": "/:username/activity",
  "billing": "/:username/my-plan",

  "overview": "/:username/overview",
  "privacy": "/:username/privacy",
  "my_plan": "/:username/my-plan",
  "my_data": "/:username/my-data",
  "activity": "/:username/activity",
  "invoice": "/:username/my-plan/invoice/:key",

  "wippers": "/:username/wippersnapper",
  "new_wipper": "/:username/wippersnapper/new",
  "update_wipper": "/:username/wippersnapper/new/:boardName",
  "wipper": "/:username/wippersnapper/:key",

  "devices": "/:username/devices",
  "new_device": "/:username/devices/new",
  "new_device_board": "/:username/devices/new/:boardName",
  "new_device_board_step": "/:username/devices/new/:boardName/step-:stepNumber",
  "new_device_board_method_step": "/:username/devices/new/:boardName/:installMethod/step-:stepNumber",
  "update_device": "/:username/devices/:key/update-firmware",
  "update_device_step": "/:username/devices/:key/update-firmware/step-:stepNumber",
  "update_device_method_step": "/:username/devices/:key/update-firmware/:installMethod/step-:stepNumber",
  "device": "/:username/devices/:key",

  "feeds": "/:username/feeds",
  "feed": "/:username/feeds/:key",
  "group_feed": "/:username/groups/:group_id/feeds/:key",
  "groups": "/:username/groups",
  "group": "/:username/groups/:key",

  "dashboards": "/:username/dashboards",
  "dashboard": "/:username/dashboards/:key",

  "actions": "/:username/actions",
  "edit_action": "/:username/actions/:id/edit",
  "edit_legacy_action": "/:username/actions/legacy/:id/edit",
  "edit_blockly_legacy_action": "/:username/actions/legacy/:id/edit_with_blockly",

  "services": "/:username/services",
  "service": "/:username/services/:name",
  "service_ifttt": "/:username/services/ifttt",
  "service_zapier": "/:username/services/zapier",
  "service_weather": "/:username/services/weather",
  "service_air_quality": "/:username/services/air_quality",
  "service_messages": "/:username/services/messages",
  "service_words": "/:username/services/words",
  "service_time": "/:username/services/time",

  "design_guide": "/:username/design_guide",

  "tokens": "/:username/tokens",
  "organizations": "/:username/organizations",
  "organization": "/:username/organizations/:key",

  "api_tokens": "/api/v2/:username/tokens",

  "downloadFeedData": "/api/v2/:username/feeds/:key/data/download",
  "downloadFeedStatus": "/api/v2/:username/feeds/:key/data/download/status",

  "downloadAccountData": "/api/v2/:username/download",
  "downloadAccountStatus": "/api/v2/:username/download/status",

  "downloadAllData": "/api/v2/:username/settings/download_all_data",
  "destroyAllData": "/api/v2/:username/settings/destroy_all_data",
  "unsetBetaFlag": "/api/v2/:username/settings/unset_beta_flag",

  "api_dashboards": "/api/v2/:username/dashboards",
  "api_dashboard": "/api/v2/:username/dashboards/:key",
  "api_dashboard_file": "/api/v2/:username/dashboards/:key/upload_header",
  "api_dashboard_update_layouts": "/api/v2/:username/dashboards/:key/update_layouts",
  "api_data": "/api/v2/:username/feeds/:key/data",
  "api_feeds": "/api/v2/:username/feeds",
  "api_feed": "/api/v2/:username/feeds/:key",
  "api_group": "/api/v2/:username/groups/:key",
  "api_profile": "/api/v2/:username/profile",
  "api_sidebar": "/api/v2/:username/sidebar",
  "api_throttle": "/api/v2/:username/throttle",
  "feed_chart": "/api/v2/:username/feeds/:key/data/chart",

  "api_invoices": "/api/v2/:username/invoices",
  "api_invoice": "/api/v2/:username/invoices/:key",
  "api_subscription": "/api/v2/:username/subscription",
  "api_subscription_change": "/api/v2/:username/subscription/change",
  "api_subscription_preview": "/api/v2/:username/subscription/preview",
  "api_system_messages": "/api/v2/system_messages",
  "api_system_messages_dismiss": "/api/v2/system_messages/:id/dismiss",
  "api_promotion_check": "/api/v2/:username/promotion_discounts/check",
  "api_promotion_discounts": "/api/v2/:username/promotion_discounts",

  "api_sharing_notifications": "/api/v2/:username/sharing/notifications",
  "api_feed_shares": "/api/v2/:username/feeds/:key/shares",
  "api_feed_share": "/api/v2/:username/feeds/:key/shares/:id",
  "api_sharing": "/api/v2/:username/sharing",
  "api_sharing_review": "/api/v2/:username/sharing/:token",
  "sharing_review": "/:username/share/:token",
  "api_block": "/api/v2/:username/social_blocks/:id",
  "api_create_block": "/api/v2/:username/social_blocks",

  "api_approve_feed_share": "/api/v2/:username/feeds/:key/shares/:token/approve",
  "api_ignore_feed_share":  "/api/v2/:username/feeds/:key/shares/:token/ignore",
  "api_block_feed_share":   "/api/v2/:username/feeds/:key/shares/:token/block",

  "api_feedbacks": "/api/v2/feedback",
  "api_feedback": "/api/v2/feedback/:id",
  "api_unsubscribe": "/api/v2/unsubscribe",
  "api_social_reports": "/api/v2/social_reports",
  "api_new_social_report": "/api/v2/social_reports/new",

  "api_coupon_check": "/api/v2/coupons/check",
  "api_coupon_redeem": "/api/v2/coupons/redeem",

  "api_service_integration_weathers": "/api/v2/:username/integrations/weather",
  "api_service_integration_weather": "/api/v2/:username/integrations/weather/:id",

  "api_service_integration_air_qualities": "/api/v2/:username/integrations/air_quality",
  "api_service_integration_air_quality": "/api/v2/:username/integrations/air_quality/:id",

  "api_service_integration_messages": "/api/v2/:username/integrations/messages",
  "api_service_integration_message": "/api/v2/:username/integrations/messages/:id",

  "api_service_integration_words": "/api/v2/:username/integrations/words",
  "api_service_integration_word": "/api/v2/:username/integrations/words/:id",

  "api_feed_webhooks": "/api/v2/:username/feeds/:key/webhooks",
  "api_feed_webhook": "/api/v2/:username/feeds/:key/webhooks/:id",

  "api_guides": "/api/v2/guides",
  "api_guide_dismiss": "/api/v2/guides/:key/dismiss",

  "api_learn_guides_featured": "/api/v2/learn_guides/featured",

  "api_user": "/api/v2/user",
  "api_public_profile": "/api/v2/:username/public_profile",
  "api_welcome_dismiss": "/api/v2/:username/welcome/dismiss"
}
